import { render, staticRenderFns } from "./ProposalQuickFilters.vue?vue&type=template&id=e2926370&scoped=true"
import script from "./ProposalQuickFilters.vue?vue&type=script&lang=js"
export * from "./ProposalQuickFilters.vue?vue&type=script&lang=js"
import style0 from "./ProposalQuickFilters.vue?vue&type=style&index=0&id=e2926370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2926370",
  null
  
)

export default component.exports